import {
  BUTTON_DEFAULT_SIZE_CLASS_MAP,
  BUTTON_TEXT_ONLY_SIZE_CLASS_MAP,
  TButtonSize,
  TButtonVariant,
} from "./Button.config";

export const getButtonSizeClasses = (variant: TButtonVariant, size: TButtonSize): string => {
  if (variant === "text") {
    return BUTTON_TEXT_ONLY_SIZE_CLASS_MAP[size];
  }
  return BUTTON_DEFAULT_SIZE_CLASS_MAP[size];
};
